// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  width: 20px;\r\n  height: 20px;\r\n  transform: rotate(90deg);\r\n  transition: 0.38s;\r\n  transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-4e6f274c] {\r\n  transform: rotate(0deg);\n}\r\n", ""]);
// Exports
module.exports = exports;
